import Vue from 'vue';
import { gsap } from 'gsap';
import Errors from '../classes/Errors';

Vue.component('pitches-overview-component', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            listView: true,
            activeItem: null,
            imageBox: null,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.imageBox = this.$el.querySelector('.pitches-overview__list-item-image').getBoundingClientRect();

        document.querySelector('html').classList.add('yellow-bg');
    },

    beforeDestroy() {
        document.querySelector('html').classList.remove('yellow-bg');
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        toggleListview() {
            this.listView = !this.listView;
            gsap.to('.pitches-overview__free-roam-holder', {opacity: 0})
            gsap.to('.pitches-overview__list-holder', {opacity: 0})

            Vue.nextTick(() => {
                if(this.listView) {
                    gsap.to('.pitches-overview__list-holder', {opacity: 1})
                } else {
                    gsap.to('.pitches-overview__free-roam-holder', {opacity: 1})
                }
            })
        },

        handleMouseEnter(e) {
            if(document.querySelector('.no-touchevents')) {
                const parent = e.currentTarget;
                this.activeItem = {
                    parent,
                    imageHolder: parent.querySelector('.pitches-overview__list-item-image'),
                    image: parent.querySelector('.pitches-overview__list-item-image img'),
                };
    
                this.activeItem.parent.classList.add('pitches-overview__list-item--hovering');
    
                gsap.to(this.activeItem.image, {
                    transformOrigin: 'center',
                    scaleX: 1,
                    scaleY: 1,
                    duration: 0.5,
                    ease: 'power4.easeOut'
                });
    
                gsap.to(this.activeItem.image, {
                    opacity: 1,
                    duration: 0.2,
                    ease: 'power4.easeOut'
                });
            }
        },

        handleMouseMove(e) {
            if(document.querySelector('.no-touchevents')) {
                gsap.set(e.currentTarget.querySelector('.pitches-overview__list-item-image'), {
                    x: e.clientX - (this.imageBox.width / 2),
                    y: e.clientY - (this.imageBox.height / 2),
                });
            }
        },

        handleMouseLeave(e) {
            if(document.querySelector('.no-touchevents')) {
                e.currentTarget.classList.remove('pitches-overview__list-item--hovering');

                gsap.to(e.currentTarget.querySelector('.pitches-overview__list-item-image img'), {
                    transformOrigin: 'center',
                    scaleX: 0.3,
                    scaleY: 0,
                    duration: 0.5,
                    ease: 'power4.easeOut',
                    onComplete: () => {
                        this.activeItem = null;
                    }
                });

                gsap.to(this.activeItem.image, {
                    opacity: 0,
                    duration: 0.2,
                    ease: 'power4.easeOut'
                });
            }
        }
    }
});
